import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form, Button, Icon, Input, Loader, Dimmer,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';

class ContactForm extends Component {
  UNSAFE_componentWillMount() {
    const { auctionAccessName, email, phone } = this.props;
    this.setState({
      email,
      phone,
      auctionAccessName,
      userEmail: '',
      salesRepEmail: '',
    });
  }

  render() {
    const {
      auctionAccessName,
      editedRate,
      email,
      phone,
      fieldUpdateHandler,
      errors,
      submitForm,
      handleCancel,
      loading,
      isRevise,
      chosenOffer,
      submitWithoutApproval,
      isUpgrade,
      salesRepEmail,
      userEmail,
    } = this.props;

    const {
      auctionAccessName: stateAuctionAccessName,
      email: stateEmail,
      phone: statePhone,
      userEmail: stateUserEmail,
      salesRepEmail: stateSalesRepEmail,
    } = this.state;

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
      fieldUpdateHandler(field, event.target.value);
    };

    return (
      <div>
        <Form>
          <Form.Group widths='two'>
            <Form.Field error={!isEmpty(errors.auctionAccessName)}>
              <label htmlFor='name'>SEND RATE TO</label>
              <Input
                icon='pencil alternate'
                enabled
                id='name'
                name='auctionAccessName'
                placeholder={auctionAccessName}
                value={stateAuctionAccessName}
                onChange={onChangeHandler('auctionAccessName')}
              />
              {errors.auctionAccessName && (
                <span>{errors.auctionAccessName}</span>
              )}
            </Form.Field>
            <Form.Field error={!isEmpty(errors.email)}>
              <label htmlFor='email'>EMAIL ADDRESS</label>
              <Input
                icon='pencil alternate'
                enabled
                id='email'
                name='email'
                placeholder={email}
                value={stateEmail}
                onChange={onChangeHandler('email')}
              />
              {errors.email && <span>{errors.email}</span>}
            </Form.Field>
            <Form.Field>
              <label htmlFor='phone'>PHONE</label>
              <Input
                icon='pencil alternate'
                id='phone'
                name='phone'
                placeholder={phone}
                value={statePhone}
                onChange={onChangeHandler('phone')}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths='two'>
            <Form.Field error={!isEmpty(errors.userEmail)}>
              <label htmlFor='userEmail'>
                Please provide an email address to receive updates on this offer
              </label>
              <Input
                icon='pencil alternate'
                enabled
                id='userEmail'
                name='userEmail'
                placeholder={userEmail}
                value={stateUserEmail}
                onChange={onChangeHandler('userEmail')}
              />
              {errors.userEmail && <span>{errors.userEmail}</span>}
            </Form.Field>
            <Form.Field error={!isEmpty(errors.salesRepEmail)}>
              <label htmlFor='salesRepEmail'>Sales Rep Email</label>
              <Input
                icon='pencil alternate'
                enabled
                id='salesRepEmail'
                name='salesRepEmail'
                placeholder={salesRepEmail}
                value={stateSalesRepEmail}
                onChange={onChangeHandler('salesRepEmail')}
              />
              {errors.salesRepEmail && <span>{errors.salesRepEmail}</span>}
            </Form.Field>
          </Form.Group>

          {/* when the start enrolment */}
          {!isUpgrade && (
            <Button color='green' inverted onClick={submitForm}>
              <Icon name='checkmark' />
              {isRevise && 'Submit Revised Offer'}
              {!isRevise && 'Submit Offer'}
            </Button>
          )}
          {/* upgrade = true and no override rate */}
          {isUpgrade && !editedRate && (
            <Button color='green' inverted onClick={submitForm}>
              <Icon name='checkmark' />
              {isRevise && 'Submit Revised Offer'}
              {!isRevise && 'Submit Offer'}
            </Button>
          )}
          {/* upgrade = true and when override rate is greater than the offer(upgrade) */}
          {isUpgrade
            && parseInt(chosenOffer.rate, 10) <= parseInt(editedRate, 10) && (
              <Button color='green' inverted onClick={submitForm}>
                <Icon name='checkmark' />
                {isRevise && 'Submit Revised Offer'}
                {!isRevise && 'Submit Offer'}
              </Button>
          )}
          {/* upgrade = true and when override rate is less than the offer(downgrade) */}
          {isUpgrade
            && parseInt(editedRate, 10) > 0
            && parseInt(chosenOffer.rate, 10) > parseInt(editedRate, 10) && (
              <Button color='green' inverted onClick={submitWithoutApproval}>
                {' '}
                Change Enrollment Without Approval
              </Button>
          )}
          <Button color='green' inverted onClick={handleCancel}>
            <Icon /> Cancel
          </Button>
        </Form>
        {loading && (
          <Dimmer active inverted>
            <Loader size='large'>Loading</Loader>
          </Dimmer>
        )}
      </div>
    );
  }
}

ContactForm.propTypes = {
  auctionAccessName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  editedRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldUpdateHandler: PropTypes.func,
  errors: PropTypes.object,
  submitForm: PropTypes.func,
  handleCancel: PropTypes.func,
  loading: PropTypes.bool,
  isRevise: PropTypes.bool,
  chosenOffer: PropTypes.object,
  submitWithoutApproval: PropTypes.func,
  isUpgrade: PropTypes.bool,
  salesRepEmail: PropTypes.string,
  userEmail: PropTypes.string,
};

ContactForm.defaultProps = {
  auctionAccessName: '',
  email: '',
  phone: '',
  editedRate: '',
  fieldUpdateHandler: () => {},
  errors: {},
  submitForm: () => {},
  handleCancel: () => {},
  loading: false,
  isRevise: false,
  chosenOffer: {},
  submitWithoutApproval: () => {},
  isUpgrade: false,
  salesRepEmail: '',
  userEmail: '',
};

export default ContactForm;
